import { Dropdown } from "react-bootstrap";
import styled from "styled-components";

// Dark themed dropdown menu for consistent styling across the app
export const DarkDropdownMenu = styled(Dropdown.Menu)`
  background-color: #212529;
  border: 1px solid rgba(255, 255, 255, 0.15);
`;

// Dark themed dropdown item for consistent styling across the app
export const DarkDropdownItem = styled(Dropdown.Item)`
  color: #f8f9fa !important;
  text-decoration: none !important;

  &:hover {
    background-color: #343a40;
    color: #fff !important;
  }

  &:active,
  &.active {
    background-color: #28c604;
    color: #fff !important;
  }
`;
